module.exports = __webpack_public_path__ + "e71a0ccc0c2af66522620e8b0eb856f6.png";